var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile)?_c('TextFontSizeMobile',_vm._g(_vm._b({},'TextFontSizeMobile',_vm.TextFontSizeProps,false),_vm.TextFontSizeEmits)):_c('TextFontSizeDesktop',_vm._g(_vm._b({},'TextFontSizeDesktop',_vm.TextFontSizeProps,false),_vm.TextFontSizeEmits))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }